import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'getOriginalColumnName' })
export class TableGetOriginalColumnNamePipe implements PipeTransform {
  transform(column: string): string {
    return column.split('_').pop() || column;
  }
}
